import { render, staticRenderFns } from "./IndexesList.vue?vue&type=template&id=514ddbfc&scoped=true&"
import script from "./IndexesList.vue?vue&type=script&lang=js&"
export * from "./IndexesList.vue?vue&type=script&lang=js&"
import style0 from "./IndexesList.vue?vue&type=style&index=0&id=514ddbfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ddbfc",
  null
  
)

export default component.exports